const validate = values => {
  const errors = {};
  if (!values.cwdCode || values.cwdCode === null || values.cwdCode === "") {
    errors.cwdCode = "Required";
  }
  
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/wizardSection/validate.js